import { render, staticRenderFns } from "./MetricChart.vue?vue&type=template&id=4930f38c&scoped=true&"
import script from "./MetricChart.vue?vue&type=script&lang=ts&"
export * from "./MetricChart.vue?vue&type=script&lang=ts&"
import style0 from "./MetricChart.vue?vue&type=style&index=0&id=4930f38c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4930f38c",
  null
  
)

export default component.exports